import React from 'react';
import 'moment/locale/fr'
import {useState} from 'react';
import Planning from './Planning';


function AccessPlanning() {

  const [username , setUsername] = useState("");
  const [alertError , setAlertError] = useState("");
  const [isAuth , setIsAuth] = useState(false);


  const submitForm = (e) =>{
    e.preventDefault();
  }


  const onChangeUsername = (e) =>{
    setUsername(e.target.value);
  }

  const onSendForm = () => {
    if (username === "mlvo2022"){
      setIsAuth(true);
    }
    else{
      setAlertError("Erreur, vos identifiants sont incorrects .");
    }
  }


  return (

    <div>

    {
      isAuth ? 

      <Planning/>

      : 

      <form onSubmit={submitForm} id = "formAccess">
      <h2 style={{color : "black"}}>
          ACCES RESERVE AUX CONSEILLERS
      </h2>

      <label>
          <input type="password" className="connectInput" onChange={onChangeUsername} placeholder="Mot de passe"/>
          <button type="submit" className="submitBtn" onClick={onSendForm}>Se connecter</button>
      </label>

      <p style={{color : "rgb(114, 20, 20)"}}>{alertError}</p>
      <div><p style={{color : "rgb(143, 18, 18)"}}><b>L'ACCES AU PLANNING EST DESORMAIS RESERVE AUX CONSEILLERS UNIQUEMENT !</b></p></div>
      </form>
      
    }


    </div>



    

    

    

  );
}

export default AccessPlanning;
